import { PROCESS_STEPS } from "@/data/site";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { useLang } from "@/i18n";

export default function Process() {
    const { t } = useLang();
    return (
        <section id="process" data-testid="process-section" className="relative py-24 md:py-32 bg-navy">
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <Reveal>
                    <Eyebrow>{t.process.eyebrow}</Eyebrow>
                    <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tight text-ink mt-4">
                        {t.process.heading}
                    </h2>
                </Reveal>
                <div className="mt-16 relative grid gap-10 md:grid-cols-4 md:gap-6">
                    <div className="hidden md:block absolute top-7 left-[12%] right-[12%] h-px bg-gradient-to-r from-electric via-cyan2 to-solar opacity-40" aria-hidden="true" />
                    {t.process.steps.map((s, i) => (
                        <Reveal key={s.num} delay={i * 0.14}>
                            <div data-testid={`process-step-${i + 1}`} className="relative">
                                <div className="flex md:flex-col items-start md:items-center gap-5 md:gap-0 md:text-center">
                                    <span className="relative z-10 w-14 h-14 shrink-0 rounded-full bg-surface border border-cyan2/40 flex items-center justify-center font-mono2 font-medium text-cyan2 shadow-[0_0_25px_rgba(0,207,255,0.15)]">
                                        {s.num}
                                    </span>
                                    <div className="md:mt-6">
                                        <h3 className="font-heading text-lg font-semibold text-ink uppercase tracking-wide">
                                            {s.title}
                                        </h3>
                                        <p className="mt-2 text-sm text-ice/60 leading-relaxed md:max-w-[24ch] md:mx-auto">
                                            {s.description}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
